import React from 'react';
import SearchMenu, { FilterConsumer } from '../components/SearchMenu';
import Query from './Query';
function QueriesSearch() {
  return (
    <SearchMenu>
      <FilterConsumer>{(AgencyFilter) => <Query filter={AgencyFilter} />}</FilterConsumer>
    </SearchMenu>
  );
}

export default QueriesSearch;
